import { MESApiService } from "@dexteel/mesf-core";

export const getSampleTypes = async () => {
  const apiService = new MESApiService();
  return await apiService.callV2("[LAB].[GetCatSampleTypes]", []);
};
